import {GRAY7} from '/ui/colors/colors';
import {hasManaUITheme} from '/ui/design/hasManaUITheme';

const fontFamily = hasManaUITheme()
  ? 'var(--main-font-family)'
  : `'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif`;

const color = hasManaUITheme()
  ? 'var(--text-neutralDominant, var(--gray-900, #1c1d20))'
  : GRAY7;

/**
 * @param {{
 *   children?: React.ReactNode,
 *   id?: string,
 *   margin?: string,
 *   tid?: string,
 * }} props
 * @return {React.ReactElement}
 */
export const H1 = ({children, id, margin = '0', tid}) => {
  return (
    <h1
      id={id}
      style={{
        all: 'initial',
        color,
        fontFamily,
        fontSize: '25px',
        fontWeight: 'bold',
        margin,
      }}
      tid={tid}
    >
      {children}
    </h1>
  );
};

/**
 * @param {{
 *   children?: React.ReactNode,
 *   id?: string,
 *   margin?: string,
 *   tid?: string,
 * }} props
 * @return {React.ReactElement}
 */
export const H3 = ({children, id, margin = '0', tid}) => {
  return (
    <h3
      id={id}
      style={{
        all: 'initial',
        color,
        fontFamily,
        fontSize: '16px',
        fontWeight: 'bold',
        margin,
      }}
      tid={tid}
    >
      {children}
    </h3>
  );
};
